import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=b5a7fad4"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports